import React, { useEffect, useState } from 'react';
import './Footer.css';
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png';
import baseURL from '../url';

export default function Footer() {
    const [tienda, setTienda] = useState([]);

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data?.tienda?.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    return (
        <div className='FooterContain'>

            {/* Logo y Nombre */}
            <div className='footerText' id='footerText'>
                <Anchor to='/'>
                    {tienda?.imagen1 ? (
                        <img src={tienda.imagen1} alt="logo" />
                    ) : (
                        <img src={logo} alt="logo" />
                    )}
                </Anchor>

                <h2>{tienda?.nombre || "Mi Tienda"}</h2>
            </div>

            {/* ÚNICA COLUMNA: CONTACTO */}
            <div className='footerText'>
                <h3>Contacto Sucursal</h3>

                <Anchor 
                    to={`https://www.google.com/maps?q=${encodeURIComponent(tienda?.direccion || "")}`} 
                    target="_blank"
                >
                    {tienda?.direccion}
                </Anchor>

                <Anchor to={`mailto:${tienda?.email}`} target="_blank">
                    {tienda?.email}
                </Anchor>

                <div className='socials'>
                    {tienda?.instagram && (
                        <Anchor to={tienda.instagram} target="_blank">
                            <i className='fa fa-instagram'></i>
                        </Anchor>
                    )}



                    {tienda?.facebook && (
                        <Anchor to={tienda.facebook} target="_blank">
                            <i className='fa fa-facebook'></i>
                        </Anchor>
                    )}
                </div>
            </div>

        </div>
    );
}